import {ChangeDetectionStrategy, Component, computed, EventEmitter, inject, Inject, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {TemplatePortal} from '@angular/cdk/portal';
import {SidenavService} from 'src/app/core/services/sidenav.service';
import {AuthService} from 'src/app/core/services/auth.service';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {SidenavComponent} from 'src/app/layout/sidenav/sidenav.component';
import {MatIconModule} from '@angular/material/icon';
import {LogoutComponent} from '../../auth/logout/logout.component';
import {ChangePasswordComponent} from '../change-password/change-password.component';
import { SignalStore } from 'src/app/shared/functions/store.functions';
import { RoleState } from 'src/app/core/models/role.model';
import {MatSelectModule} from '@angular/material/select';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { RoleSelectComponent } from "../role-select/role-select.component";
@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.css'],
  host: {'class': 'flex flex-column align-items-center justify-content-center'},
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    SidenavComponent,
    MatSelectModule,
    ChangePasswordComponent,
    LogoutComponent,
    RoleSelectComponent
],
})
export class UserAvatarComponent {
  public sidenavVisible: boolean = false;
  readonly avatar = computed(() => this.authService.user()?.avatar);
  readonly username = computed(() => this.authService.user()?.username || 'No user info');
  readonly email = computed(() => this.authService.user()?.email);
  readonly createdAt = computed(() => this.authService.user()?.created.createdAt);
  readonly roles = computed(()=>this.authService.user()?.authorization.roles)
  rolesSelected = this.roleStore.selectKey("role")
  selected = parseInt(this.localStorageService.getItem('role')!);

  constructor(
    private authService: AuthService,
    public sidenavService: SidenavService,
    private localStorageService: LocalStorageService,
    private vcf: ViewContainerRef,
    @Inject('role-store') private readonly roleStore = inject(SignalStore<RoleState>)
  ) {

  }
  
  openRightPanel(templateRef: TemplateRef<any>) {
    const portal = new TemplatePortal(templateRef, this.vcf);
    this.sidenavService.pushContent(portal);
  }
  isSetRole() {
    return this.authService.isSetUser();
  }
  isAuthenticated() {
    return this.authService.isAuthenticated();
  }

  onLogoutClick() {
    this.sidenavService.close();
  }
}
